var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "details-view" },
    [
      _c(
        "cargo-left-right-resize",
        {
          staticStyle: { "min-height": "100%" },
          attrs: {
            "left-style": {
              flex: "none",
              width: "260px",
              "max-width": "480px"
            },
            "right-style": { overflow: "hidden" },
            "show-left": _vm.action === "look" && !_vm.bpmLook
          }
        },
        [
          _c(
            "template",
            { slot: "left" },
            [
              _c("cargo-ag-grid", {
                staticClass: "section grid-fill",
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.gridOptions,
                  "row-data": _vm.rowData
                },
                on: {
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c("template", { slot: "right" }, [
            _c("div", { staticClass: "main-content" }, [
              _c(
                "div",
                {
                  staticClass: "operations",
                  staticStyle: { "margin-bottom": "5px" }
                },
                [
                  _c("div", { staticClass: "triggers" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.action === "look" && !_vm.bpmLook,
                            expression: "action==='look' && !bpmLook"
                          }
                        ]
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { no: "goBack", type: "primary" },
                            on: { click: _vm.goBack }
                          },
                          [_vm._v(_vm._s(_vm.$t("common.btn.back")))]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isShowPartner,
                                expression: "isShowPartner"
                              },
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: ["write_SMPartner"],
                                expression: "['write_SMPartner']"
                              }
                            ],
                            attrs: {
                              no: "editHandler",
                              disabled:
                                _vm.isEditPartner ||
                                (_vm.currentRow &&
                                  Number(_vm.currentRow.approvedState) === 3),
                              type: "primary"
                            },
                            on: { click: _vm.editHandler }
                          },
                          [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                        ),
                        _vm.partnersApproved > 0
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "toAudit",
                                  disabled: !(
                                    _vm.auditBtnPermission &&
                                    _vm.currentRow &&
                                      Number(_vm.currentRow.approvedState) === 0
                                  ),
                                  type: "primary"
                                },
                                on: { click: _vm.toAudit }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.audit")))]
                            )
                          : _vm._e(),
                        _vm.isCancelPartnersApproved
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "toCancelAudit",
                                  disabled: !(
                                    _vm.cancelAuditBtnPermission &&
                                    _vm.currentRow &&
                                    Number(_vm.currentRow.approvedState) === 1
                                  ),
                                  type: "primary"
                                },
                                on: { click: _vm.toCancelAudit }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_CancelAudit"))
                                )
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: ["button_SMPartner_cancelSpecial"],
                                expression: "['button_SMPartner_cancelSpecial']"
                              }
                            ],
                            attrs: {
                              no: "specialFeeLimitApply",
                              type: "primary"
                            },
                            on: { click: _vm.openSpecialFeeLimitApplyDialog }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "CargoMsg.Cargo_SpecialFeeLimitReleaseApply"
                                )
                              )
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: ["button_SMPartner_releaseApplication"],
                                expression:
                                  "['button_SMPartner_releaseApplication']"
                              }
                            ],
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                _vm.releaseApplicationDialog.visible = true
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "CargoMsg.Cargo_TemporaryNumberReleaseApplication"
                                )
                              )
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.action === "new",
                            expression: "action==='new'"
                          }
                        ]
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { no: "goBack", type: "primary" },
                            on: { click: _vm.goBack }
                          },
                          [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: ["write_SMPartner"],
                                expression: "['write_SMPartner']"
                              }
                            ],
                            attrs: { no: "save", type: "primary" },
                            on: { click: _vm.save }
                          },
                          [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.action === "edit",
                            expression: "action==='edit'"
                          }
                        ]
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { no: "againShow", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.againShow("look")
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: ["write_SMPartner"],
                                expression: "['write_SMPartner']"
                              }
                            ],
                            attrs: { no: "partnerSave", type: "primary" },
                            on: { click: _vm.save }
                          },
                          [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                        )
                      ],
                      1
                    )
                  ])
                ]
              ),
              _c(
                "div",
                { staticClass: "tabs-container" },
                [
                  _c(
                    "el-tabs",
                    {
                      ref: "tabs",
                      staticStyle: { width: "100%", "min-width": "1000px" },
                      attrs: { type: "card" },
                      on: { "tab-click": _vm.handleTabClick },
                      model: {
                        value: _vm.activeTabName,
                        callback: function($$v) {
                          _vm.activeTabName = $$v
                        },
                        expression: "activeTabName"
                      }
                    },
                    [
                      _c(
                        "el-tab-pane",
                        {
                          key: 1,
                          attrs: {
                            name: "basicInfo",
                            label: _vm.$t("baseInfo.partner.basicInfo.title")
                          }
                        },
                        [
                          _c("basic-info", {
                            ref: "basicInfo",
                            attrs: {
                              "service-type": _vm.serviceType,
                              action: _vm.action,
                              "current-row": _vm.currentRow,
                              "oujian-edit-limit": _vm.oujianEditLimit,
                              "is-sales-for-szfs": _vm.isSalesForSzfs
                            },
                            on: { rowChange: _vm.onRowChange }
                          })
                        ],
                        1
                      ),
                      !this.$checkPermission(["tab_hide_contact"], true)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 2,
                              attrs: {
                                lazy: true,
                                name: "contactForm",
                                label: _vm.$t("Payment.contactPerson")
                              }
                            },
                            [
                              _c("contact-form", {
                                ref: "contactForm",
                                attrs: {
                                  action: _vm.canEditContact
                                    ? _vm.action
                                    : "look"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.customer &&
                      _vm.checkTabCustomer &&
                      !this.$checkPermission(["tab_hide_customer"], true)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 3,
                              attrs: {
                                lazy: true,
                                name: "customerForm",
                                label: _vm.$t("Payment.customer")
                              }
                            },
                            [
                              _c("customer-form", {
                                ref: "customerForm",
                                attrs: {
                                  action: _vm.canEditCustomer
                                    ? _vm.action
                                    : "look",
                                  "is-sales-for-szfs": _vm.isSalesForSzfs
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-tab-pane",
                        {
                          key: 4,
                          attrs: {
                            lazy: true,
                            disabled: !_vm.canEditCredit,
                            name: "creditInfoForm",
                            label: _vm.$t("Partners.creditAccount")
                          }
                        },
                        [
                          _c("credit-info-form", {
                            ref: "creditInfoForm",
                            attrs: {
                              action: _vm.action,
                              "branch-id": _vm.currentRow.branchId,
                              "oujian-edit-limit": _vm.oujianEditLimit
                            }
                          })
                        ],
                        1
                      ),
                      _vm.$checkPermission(["tab_CustomerContractNumber"])
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 5,
                              attrs: {
                                lazy: true,
                                name: "contractForm",
                                label: _vm.$t("Partners.contractNumber")
                              }
                            },
                            [
                              _c("contract-form", {
                                ref: "contractForm",
                                attrs: { action: _vm.action }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !!_vm.paramsOfTab.uuid &&
                      !this.$checkPermission(["tab_hide_document"], true)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 5.5,
                              attrs: {
                                lazy: true,
                                name: "documentForm",
                                label: _vm.$t("Partners.documentation")
                              }
                            },
                            [
                              _c("document-form", {
                                ref: "documentForm",
                                attrs: {
                                  action: _vm.canEditDocument
                                    ? _vm.action
                                    : "look"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.customer &&
                      _vm.checkTabCustomer &&
                      !this.$checkPermission(["tab_hide_site"], true)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 6,
                              attrs: {
                                lazy: true,
                                name: "siteForm",
                                label: _vm.$t("Partners.doorInformation")
                              }
                            },
                            [
                              _c("site-form", {
                                ref: "siteForm",
                                attrs: {
                                  action: _vm.canEditSite ? _vm.action : "look"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.customer &&
                      _vm.checkTabCustomer &&
                      !this.$checkPermission(["tab_hide_specialRequest"], true)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 7,
                              attrs: {
                                lazy: true,
                                name: "specialRequestForm",
                                label: _vm.$t("Partners.specialRequirements")
                              }
                            },
                            [
                              _c("special-request-form", {
                                ref: "specialRequestForm",
                                attrs: {
                                  action: _vm.canEditSpecialRequest
                                    ? _vm.action
                                    : "look"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.checkTabTitle &&
                      !this.$checkPermission(["tab_hide_invoiceRequest"], true)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 8,
                              attrs: {
                                lazy: true,
                                name: "titleForm",
                                label: _vm.$t("Invoice.invoice_sp15")
                              }
                            },
                            [
                              _c("title-form", {
                                ref: "titleForm",
                                attrs: {
                                  action: _vm.canEditInvoiceRequest
                                    ? _vm.action
                                    : "look"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.customer &&
                      _vm.checkSupplyChain &&
                      !this.$checkPermission(["tab_hide_supplyChain"], true)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 8.5,
                              attrs: {
                                lazy: true,
                                name: "supplyChainForm",
                                label: _vm.$t("Partners.supplyChainLines")
                              }
                            },
                            [
                              _c("supply-chain-form", {
                                ref: "supplyChainForm",
                                attrs: {
                                  action: _vm.canEditSupplyChain
                                    ? _vm.action
                                    : "look"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.bookingAgent &&
                      _vm.checkTabBooking &&
                      !this.$checkPermission(["tab_hide_exchangeAgent"], true)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 24,
                              attrs: {
                                lazy: true,
                                name: "exchangeAgentForm",
                                label: _vm.$t("SeaExport.BillExchangeAgent")
                              }
                            },
                            [
                              _c("exchange-agent-form", {
                                ref: "exchangeAgentForm",
                                attrs: {
                                  action: _vm.canEditExchangeAgent
                                    ? _vm.action
                                    : "look"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.overseaAgent &&
                      _vm.checkTabAgent &&
                      !this.$checkPermission(["tab_hide_overseaAgent"], true)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 9,
                              attrs: {
                                lazy: true,
                                name: "overseaAgentForm",
                                label: _vm.$t(
                                  "Partners.destinationPortHandlingAgent"
                                )
                              }
                            },
                            [
                              _c("oversea-agent-form", {
                                ref: "overseaAgentForm",
                                attrs: {
                                  action: _vm.canEditOverseaAgent
                                    ? _vm.action
                                    : "look"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.designationAgent &&
                      _vm.checkTabAgent &&
                      !this.$checkPermission(
                        ["tab_hide_designationAgent"],
                        true
                      )
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 10,
                              attrs: {
                                lazy: true,
                                name: "designationAgentForm",
                                label: _vm.$t(
                                  "Partners.destinationNominatedAgent"
                                )
                              }
                            },
                            [
                              _c("designation-agent-form", {
                                ref: "designationAgentForm",
                                attrs: {
                                  action: _vm.canEditDesignationAgent
                                    ? _vm.action
                                    : "look"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.designationAgent &&
                      _vm.checkTabAgent &&
                      !this.$checkPermission(
                        ["tab_hide_overseaAgentPort"],
                        true
                      )
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 11,
                              attrs: {
                                lazy: true,
                                name: "overseaAgentPortForm",
                                label: _vm.$t("Partners.portLocation")
                              }
                            },
                            [
                              _c("oversea-agent-port-form", {
                                ref: "overseaAgentPortForm",
                                attrs: {
                                  action: _vm.canEditOverseaAgentPort
                                    ? _vm.action
                                    : "look"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.bookingAgent &&
                      _vm.checkTabBooking &&
                      _vm.canCarrierCredit &&
                      !this.$checkPermission(
                        ["tab_hide_bookingAgentCarrier"],
                        true
                      )
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 12,
                              attrs: {
                                lazy: true,
                                name: "bookingAgentCarrierForm",
                                label: _vm.$t("Partners.spaceCarrier")
                              }
                            },
                            [
                              _c("booking-agent-carrier-form", {
                                ref: "bookingAgentCarrierForm",
                                attrs: {
                                  action: _vm.canEditBookingAgentCarrier
                                    ? _vm.action
                                    : "look"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      (_vm.paramsOfTab.seaCmp || _vm.paramsOfTab.airCmp) &&
                      (_vm.checkTabShippingCompany ||
                        _vm.checkTabAirlineCompany) &&
                      !this.$checkPermission(
                        ["tab_hide_carrierBookingAgent"],
                        true
                      )
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 13,
                              attrs: {
                                lazy: true,
                                name: "carrierBookingAgentForm",
                                label: _vm.$t("Partners.spaceAgent")
                              }
                            },
                            [
                              _c("carrier-booking-agent-form", {
                                ref: "carrierBookingAgentForm",
                                attrs: {
                                  action: _vm.canEditCarrierBookingAgent
                                    ? _vm.action
                                    : "look"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.warehouse &&
                      _vm.checkTabWarehouse &&
                      !this.$checkPermission(["tab_hide_warehouse"], true)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 14,
                              attrs: {
                                lazy: true,
                                name: "warehouseForm",
                                label: _vm.$t("Partners.warehouseInformation")
                              }
                            },
                            [
                              _c("warehouse-form", {
                                ref: "warehouseForm",
                                attrs: {
                                  action: _vm.canEditWarehouse
                                    ? _vm.action
                                    : "look"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.airCmp &&
                      _vm.checkTabAirlineCompany &&
                      !this.$checkPermission(["tab_hide_airline"], true)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 15,
                              attrs: {
                                lazy: true,
                                name: "airlineForm",
                                label: _vm.$t("SeaExport.AirlineCompany")
                              }
                            },
                            [
                              _c("airline-form", {
                                ref: "airlineForm",
                                attrs: {
                                  action: _vm.canEditAirline
                                    ? _vm.action
                                    : "look"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.serviceType !== "AIRLINE" &&
                      !this.$checkPermission(["tab_hide_shipping"], true)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 16,
                              attrs: {
                                lazy: true,
                                name: "shippingForm",
                                label: _vm.$t("Partners.EDIConfiguration")
                              }
                            },
                            [
                              _c("shipping-form", {
                                ref: "shippingForm",
                                attrs: {
                                  action: _vm.canEditShipping
                                    ? _vm.action
                                    : "look",
                                  "is-sales-for-szfs": _vm.isSalesForSzfs
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      (_vm.paramsOfTab.shipper ||
                        _vm.paramsOfTab.consignee ||
                        _vm.paramsOfTab.notify) &&
                      !this.$checkPermission(["tab_hide_manifestAddress"], true)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 17,
                              attrs: {
                                lazy: true,
                                name: "manifestAddress",
                                label: _vm.$t("Partners.AddressInformation")
                              }
                            },
                            [
                              _c("manifest-address-form", {
                                ref: "manifestAddress",
                                attrs: {
                                  action: _vm.canEditManifestAddress
                                    ? _vm.action
                                    : "look"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !!_vm.paramsOfTab.uuid &&
                      _vm.isContractBinding &&
                      !this.$checkPermission(
                        ["tab_hide_fclContractNoPrice"],
                        true
                      )
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 19,
                              attrs: {
                                name: "navFclContractNoPrice",
                                label: _vm.$t(
                                  "CargoMsg.Cargo_FclApproximatePrice"
                                )
                              }
                            },
                            [
                              _c("tab-contract-no-price-fcl", {
                                ref: "navFclContractNoPrice",
                                attrs: {
                                  action: _vm.canEditFclContractNoPrice
                                    ? _vm.action
                                    : "look"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !!_vm.paramsOfTab.uuid &&
                      _vm.isContractBinding &&
                      !this.$checkPermission(
                        ["tab_hide_lclContractNoPrice"],
                        true
                      )
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 20,
                              attrs: {
                                name: "navLclContractNoPrice",
                                label: _vm.$t(
                                  "CargoMsg.Cargo_LclApproximatePrice"
                                )
                              }
                            },
                            [
                              _c("tab-contract-no-price-lcl", {
                                ref: "navLclContractNoPrice",
                                attrs: {
                                  action: _vm.canEditLclContractNoPrice
                                    ? _vm.action
                                    : "look",
                                  "load-type": "LCL"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !!_vm.paramsOfTab.uuid &&
                      _vm.$checkPermission(["tab_TabCustomerEvent"])
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 21,
                              attrs: {
                                name: "navTabCustomerEvent",
                                label: _vm.$t("CargoMsg.Cargo_EventRecord")
                              }
                            },
                            [
                              _c("tab-customer-event", {
                                ref: "navTabCustomerEvent",
                                attrs: { action: _vm.action }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.parentCompany &&
                      !this.$checkPermission(
                        ["tab_hide_subsidiaryInformation"],
                        true
                      )
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 22,
                              attrs: {
                                lazy: true,
                                name: "subsidiaryInformation",
                                label: _vm.$t("Partners.subsidiaryInformation")
                              }
                            },
                            [
                              _c("subsidiary-information", {
                                ref: "subsidiaryInformation",
                                attrs: {
                                  action: _vm.canEditSubsidiaryInformation
                                    ? _vm.action
                                    : "look"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.terminalCompany &&
                      !this.$checkPermission(["tab_hide_terminalCompany"], true)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 23,
                              attrs: {
                                name: "terminalCompany",
                                label: _vm.$t("Message.TerminalCompany")
                              }
                            },
                            [
                              _c("terminal-company", {
                                ref: "terminalCompany",
                                attrs: {
                                  action: _vm.canEditTerminalCompany
                                    ? _vm.action
                                    : "look"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.truckCmp &&
                      !this.$checkPermission(
                        ["tab_hide_driverInformation"],
                        true
                      )
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 25,
                              attrs: {
                                lazy: true,
                                name: "driverInformationForm",
                                label: _vm.$t("Partners.DriverInformation")
                              }
                            },
                            [
                              _c("driver-information-form", {
                                ref: "driverInformationForm",
                                attrs: {
                                  action: _vm.canEditDriverInformation
                                    ? _vm.action
                                    : "look"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.hasUiConfig &&
                      !this.$checkPermission(
                        ["tab_hide_customerVendorRating"],
                        true
                      )
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 26,
                              attrs: {
                                name: "customerVendorRating",
                                label: _vm.$t(
                                  "CargoMsg.Cargo_CustomerVendorRating"
                                )
                              }
                            },
                            [
                              _c("customer-vendor-rating", {
                                ref: "customerVendorRating",
                                attrs: {
                                  action: _vm.canEditCustomerVendorRating
                                    ? _vm.action
                                    : "look"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.truckCmp &&
                      !this.$checkPermission(
                        ["tab_hide_truckClassification"],
                        true
                      )
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 27,
                              attrs: {
                                lazy: true,
                                name: "truckClassificationForm",
                                label: "车队分类"
                              }
                            },
                            [
                              _c("truck-classification-form", {
                                ref: "truckClassificationForm",
                                attrs: {
                                  action: _vm.canEditTruckClassification
                                    ? _vm.action
                                    : "look"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ],
        2
      ),
      _vm.checkingSaveJobWindow.visible
        ? _c("checking-save-job-window", {
            attrs: {
              visible: _vm.checkingSaveJobWindow.visible,
              lob: _vm.checkingSaveJobWindow.lob,
              "row-data": _vm.checkingSaveJobWindow.rowData,
              "check-node": _vm.checkingSaveJobWindow.checkNode,
              "call-back": _vm.checkingSaveJobWindow.callBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.checkingSaveJobWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.specialFeeLimitApplyDialog.visible,
            title: _vm.$t("CargoMsg.Cargo_SpecialFeeLimitReleaseApply"),
            width: "600px",
            "close-on-click-modal": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.specialFeeLimitApplyDialog, "visible", $event)
            },
            closed: _vm.resetSpecialFeeLimitApplyDialog
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "specialFeeLimitApplyForm",
              attrs: {
                model: _vm.specialFeeLimitApplyDialog.form,
                rules: _vm.specialFeeLimitApplyRules,
                "label-width": "90px",
                "label-position": "right"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Partners.chineseName") } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.specialFeeLimitApplyDialog.form.chineseName,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.specialFeeLimitApplyDialog.form,
                          "chineseName",
                          $$v
                        )
                      },
                      expression: "specialFeeLimitApplyDialog.form.chineseName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Application_Content"),
                    prop: "applyContent"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: 4 },
                    model: {
                      value: _vm.specialFeeLimitApplyDialog.form.applyContent,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.specialFeeLimitApplyDialog.form,
                          "applyContent",
                          $$v
                        )
                      },
                      expression: "specialFeeLimitApplyDialog.form.applyContent"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Application_Reason"),
                    prop: "applyReason"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: 4 },
                    model: {
                      value: _vm.specialFeeLimitApplyDialog.form.applyReason,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.specialFeeLimitApplyDialog.form,
                          "applyReason",
                          $$v
                        )
                      },
                      expression: "specialFeeLimitApplyDialog.form.applyReason"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Pricing.Attachment") } },
                [
                  _c(
                    "div",
                    { staticClass: "upload-file-row" },
                    [
                      _vm.hasSpecialFeeLimitUploadedFile
                        ? [
                            _c("span", { staticClass: "upload-file-name" }, [
                              _vm._v(
                                _vm._s(_vm.getSpecialFeeLimitUploadedFileName())
                              )
                            ]),
                            _c("el-button", {
                              staticClass: "upload-file-remove",
                              attrs: { type: "text", icon: "el-icon-close" },
                              on: {
                                click: _vm.handleRemoveSpecialFeeLimitUpload
                              }
                            })
                          ]
                        : _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.cloudFile.visible = true
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("CargoMsg.Cargo_Upload")) +
                                  " "
                              )
                            ]
                          )
                    ],
                    2
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "submitSpecialFeeLimitApply", type: "primary" },
                  on: { click: _vm.submitSpecialFeeLimitApply }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Submit")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancelSpecialFeeLimitApply" },
                  on: {
                    click: function($event) {
                      _vm.specialFeeLimitApplyDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("release-application-dialog", {
        attrs: {
          visible: _vm.releaseApplicationDialog.visible,
          "cmp-idx": _vm.currentRow.cmpIdx
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.releaseApplicationDialog, "visible", $event)
          }
        }
      }),
      _c("cargo-cloud-file-upload", {
        attrs: {
          visible: _vm.cloudFile.visible,
          job: _vm.cloudFile.job,
          lob: _vm.cloudFile.lob
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cloudFile, "visible", $event)
          },
          uploadDone: function(data) {
            _vm.uploadSpecialFeeLimitFileSuccess(data)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }